module.exports = __webpack_public_path__ + "img/knu2_gallery19.c7b24a0f.jpg";